// src/components/strumenti/NumeroMinimoSerieFV.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function NumeroMinimoSerieFV() {
  const [vmpp, setVmpp] = useState("");
  const [coeff, setCoeff] = useState("-0.40");
  const [tempMax, setTempMax] = useState("70");
  const [vmpptMin, setVmpptMin] = useState("");

  const Vmpp = leggiNumero(vmpp)||0;
  const beta = leggiNumero(coeff)||0;
  const T = leggiNumero(tempMax);
  const VmpptMin = leggiNumero(vmpptMin)||0;

  const deltaT = T-25;
  const vmppCorretto = Vmpp*(1+(beta/100)*deltaT);
  const numMin = (Vmpp>0 && VmpptMin>0 && vmppCorretto>0) ? Math.ceil(VmpptMin/vmppCorretto) : null;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Vmpp pannello a STC (V)</label>
          <input value={vmpp} onChange={e=>setVmpp(e.target.value)} style={inp} placeholder="Es. 34.5"/>
        </div>
        <div>
          <label style={lbl}>Coefficiente temperatura Vmpp (%/°C)</label>
          <input value={coeff} onChange={e=>setCoeff(e.target.value)} style={inp}/>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Temperatura massima cella di esercizio (°C)</label>
          <input value={tempMax} onChange={e=>setTempMax(e.target.value)} style={inp}/>
        </div>
        <div>
          <label style={lbl}>Vmppt minimo inverter (V)</label>
          <input value={vmpptMin} onChange={e=>setVmpptMin(e.target.value)} style={inp} placeholder="Es. 200"/>
        </div>
      </div>

      <div style={{ background:"#fff7ed", border:"1px solid #fed7aa", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Numero minimo di pannelli in serie</div>
        <div style={{ fontSize:26, fontWeight:800, color:"#c2410c" }}>
          {numMin!==null ? numMin : "—"}
        </div>
        {numMin!==null && <div style={{ fontSize:11, color:"#6b7280", marginTop:4 }}>Vmpp stringa a temperatura massima: {(vmppCorretto*numMin).toFixed(1)} V</div>}
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Garantisce che l'MPPT resti nella sua finestra di funzionamento anche nelle giornate calde — non stima la produzione.
      </div>

      <button onClick={()=>{setVmpp("");setCoeff("-0.40");setTempMax("70");setVmpptMin("");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
